import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-unauthenticated',
  templateUrl: './unauthenticated.component.html',
  styleUrls: ['./unauthenticated.component.scss'],
  standalone: false,
})
export class UnauthenticatedComponent implements OnInit {
  constructor(private oauthService: OAuthService) {}

  ngOnInit(): void {}

  public async login(): Promise<void> {
    this.oauthService.logOut();

    if (!this.oauthService.loginUrl) {
      await this.oauthService.loadDiscoveryDocument();
    }

    this.oauthService.initLoginFlow();
  }
}
